module.exports = __webpack_public_path__ + "img/occitania.39a27b6c.svg";